module.exports = __webpack_public_path__ + "img/title-4.7ee4f126.png";